import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import axios from "axios";
import { API_BASE_URL } from '../config/api';
import axiosClient from "../api/axiosClient";
import Alert from "./Alert";

const ToolsDownload = () => {
	const [username, setUsername] = useState("");
	const [generating, setGenerating] = useState(false);
	const [posts, setPosts] = useState([]);
	const [videos, setVideos] = useState([]);
	const [foundPost, setFoundPost] = useState(true);
	const [pagination, setPagination] = useState();
	const [functionError, setFunctionError] = useState("");
	const [functionSuccess, setFunctionSuccess] = useState("");


	const downloadPost = async () => {
		try {
		  // Resetting states for initial request, not clearing them for paginated requests
		  if (pagination === null) {
			setPosts([]);
			setVideos([]);
			setFoundPost(true);
		  }
		  setGenerating(true);
	  
		  const formData = {
			username: username,
			pagination_token: pagination, // Pass current pagination token
		  };
	  
		  const response = await axiosClient.post("https://api.viralgpt.com/tools/download", formData, {
			headers: {
			  "Content-Type": "application/json",
			},
		  });
	  
		  // Stop loading spinner
		  setGenerating(false);
	  
		  // Append the new data to existing arrays
		  setPosts((prevPosts) => [...prevPosts, ...response.data.posts]);
		  setVideos((prevVideos) => [...prevVideos, ...response.data.videos]);
	  
		  // Check if posts or videos exist
		  if (response.data.posts.length === 0 && response.data.videos.length === 0) {
			setFoundPost(false);
		  } else {
			setFoundPost(true);
		  }
	  
		  // Update pagination token if available
		  if (response.data.pagination_token) {
			setPagination(response.data.pagination_token);
		  } else {
			setPagination(null); // No more data, so null the token
		  }
	  
		  console.log("Server response:", response.data);
		  setFunctionSuccess("Successfully found posts to download.");
		} catch (e) {
		  setGenerating(false);
		  setFunctionError("An error occurred while downloading the post: " + e.response.data.error);
		   
		}
	  };
	  





  return (
	<>
	<div className="bg-white border  p-6">
		<h5> Post Downloader </h5>
		<p className="text-muted">Enter a username or link to download.</p>

		<Alert 
			variant="danger" 
			message={functionError} 
			show={!!functionError} 
			onClose={() => setFunctionError("")} 
		/>
		
		<Alert 
			variant="success" 
			message={functionSuccess} 
			show={!!functionSuccess} 
			onClose={() => setFunctionSuccess("")} 
		/>

		{/* Link Input */}
		<Form.Group controlId="commentsLink" className="mb-3">
		<Form.Label>Username or Post URL</Form.Label>
		<Form.Control
			type="text"
			placeholder="Enter a username or post link"
			value={username}
			onChange={(e) => setUsername(e.target.value)}
		/>
		</Form.Group>

		<div className="d-flex align-items-center">
			<Button className={generating || username == '' ? "disabled bg-instagram" : "bg-instagram"} onClick={() => downloadPost()}>
				{username == '' && ("Enter a username or post link")}
				{username.includes(":") && ("Download Post")}
				{!username.includes(":") && username.length > 0 && ("Search Profile")}
			</Button>
	
			<div style={{fontSize: "1.5rem"}} className={`ms-2 fa fa-circle-notch fa-spin text-instagram ${!generating ? "d-none" : ""}`}/>
		</div>
		{foundPost == false ? <p> No posts were found</p> : <p></p>}
		
		
	{(posts.length > 0 || videos.length > 0) && (
	<Tab.Container defaultActiveKey={posts.length > 0 ? "posts" : "reels"} >
        <Nav variant="tabs" className="mb-4">
		 {posts.length > 0 && (
          <Nav.Item>
            <Nav.Link eventKey="posts"><i class="fa fa-table-cells me-2"></i>Posts</Nav.Link>
          </Nav.Item>
		 )}
		 {videos.length > 0 && (
          <Nav.Item>
            <Nav.Link eventKey="reels"><i class="fa fa-clapperboard me-2"></i>Reels</Nav.Link>
          </Nav.Item>
		 )}

		

        </Nav>

        <Tab.Content>
		
          {/* Likes Tab */}
		  
          <Tab.Pane eventKey="posts">
		  <div className="row">
				
		  {posts.map((idea, index) => (
					<div
					key={index}
					className="col-12 col-md-6 col-lg-4 position-relative"
					style={{
						marginBottom: "1rem",  // Optional spacing between rows
					}}
					>
						<img src={idea + "#t=0.1"} alt="media" className="h-auto" />
						<Button 
							
							className="bg-instagram mt-2 position-absolute top-0 end-0 m-3" 
							onClick={() => window.open(idea, "_blank")}
						>
							<i className="fa fa-download"></i>
						</Button>
					</div>
				))}
			</div>
			
          </Tab.Pane>

          {/* Views Tab */}
		
		  <Tab.Pane eventKey="reels">
		  <div className="row">
		   {videos.map((idea, index) => (
					<div
					key={index}
					className="col-12 col-md-6 col-lg-4 position-relative"
					style={{
						marginBottom: "1rem",  // Optional spacing between rows
					}}
					>
			
					<video className="h-auto" controls>
						<source src={idea} type="video/mp4" />
						Your browser does not support the video tag.
					</video>
					<Button 
						variant="primary" 
						className="bg-instagram  mt-2 position-absolute top-0 end-0 m-3" 
						onClick={() => window.open(idea, "_blank")}
					>
						<i className="fa fa-download"></i> 
					</Button>
					</div>
				))}
			</div>
		</Tab.Pane>


        </Tab.Content>	
		<div className="d-flex justify-content-center mt-4">
				<Button
			className={generating ? "disabled bg-instagram w-100" : "bg-instagram w-100"}
			onClick={downloadPost}
			disabled={generating || !pagination} // Disable if no more data or still generating
			>
			{generating ? "Loading..." : pagination ? "Load More" : "No More Data"}
			</Button>
		</div>	
      </Tab.Container>)}
	  </div>
		
	</>
  );
};

export default ToolsDownload;
